exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-892c04ba] .vs__dropdown-option {\n    padding: 7px 20px;\n    box-shadow: 0 1px #dddddd;\n}\n", ""]);

// exports
